import { useCallback, useState } from 'react';

/**
 * État React persisté dans localStorage.
 * Lecture paresseuse à l'initialisation, écriture à chaque changement.
 */
export function useLocalStorage<T>(key: string, initialValue: T) {
  const [value, setValue] = useState<T>(() => {
    try {
      const stored = window.localStorage.getItem(key);
      return stored !== null ? (JSON.parse(stored) as T) : initialValue;
    } catch {
      return initialValue;
    }
  });

  const set = useCallback(
    (next: T | ((previous: T) => T)) => {
      setValue((previous) => {
        const resolved = typeof next === 'function' ? (next as (p: T) => T)(previous) : next;
        try {
          window.localStorage.setItem(key, JSON.stringify(resolved));
        } catch {
          // Quota dépassé ou stockage indisponible : on ignore silencieusement.
        }
        return resolved;
      });
    },
    [key],
  );

  return [value, set] as const;
}
